module.exports = __webpack_public_path__ + "static/improved-csat-hero-5af141a5f67a32b4f924d65184b2713e.png";